module.exports = __webpack_public_path__ + "img/car.34ca64e7.png";